import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class Veevavault {
  async getVeevaObjects(Workspace_id, Stage_id) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/veevaVault/${Stage_id}`)).data;
  }

  async getVeevaFields(Workspace_id, Stage_id, object) {
    return (await fetchApi.get(`/workspace/${Workspace_id}/veevaVault/${Stage_id}/${object}`)).data;
  }

  async runVeevaQuery(Workspace_id, Stage_id, postData) {
    return (await fetchApi.post(`/workspace/${Workspace_id}/veevaVault/${Stage_id}/runquery`, postData)).data;
  }
}
